import { PositionAnalyticsNetworkResponseDto } from '../models/dto/response/position/position-analytics-response.dto';
import axiosInstance from '.';

export const getPositionAnalytics = async (positionId: string): Promise<PositionAnalyticsNetworkResponseDto> => {
  // TODO: change to rtk
  const response = await axiosInstance.get(`/v1/positions/${positionId}/analytics`);

  return response.data;
};
